export type { ScreenSectionProps, SectionHeaderProps } from '../../types/section';
export { ScreenSection } from './adapters/inbound/ScreenSection';
export { SectionHeader } from './adapters/inbound/SectionHeader';
